import { render, staticRenderFns } from "./ItemClassRoomGridView.vue?vue&type=template&id=5996264b&scoped=true&"
import script from "./ItemClassRoomGridView.vue?vue&type=script&lang=js&"
export * from "./ItemClassRoomGridView.vue?vue&type=script&lang=js&"
import style0 from "./ItemClassRoomGridView.vue?vue&type=style&index=0&id=5996264b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996264b",
  null
  
)

export default component.exports